import { useState, memo, useCallback } from 'react';

import StageButton from '../StageButton';
import DepartureDialog from './DepartureDialog';
import { StyledTableCell } from 'Utils';
import { useDispatch, useSelector } from 'react-redux';
import { REQUEST_ACTIONS, sendRequest } from 'utils/Communicator';
import { snackbarToggle } from 'reducers/snackbarSlicer';

const Departure = ({ loginUser, order }) => {
    const dispatch = useDispatch();
    const failedCallback = useCallback(message => dispatch(snackbarToggle({ type: 'error', message })), [dispatch]);
    const currentStage = order.orderStage ? order.orderStage[4] : null;
    const getStatus = () => {
        if (order.orderStage && order.orderStage[4].status == "FAILED") {
            return { status: "FAILED" };
        }
        if (order.orderStage && order.orderStage[4].status == "IN_PROGRESS") {
            var gap = getGap();
            var etaWH = order.orderStage[3].whStageStage[0]?.etdTime;
            var etd = order.orderStage[4].departureStage[0]?.etd;
            if (!etd)
                etd = etaWH;
            if (!etd)
                return { status: "IN_PROGRESS" };
            var etdDate = new Date(etd);
            var curDate = new Date();
            var etdDateTime = etdDate.getTime();
            var curDateTime = curDate.getTime();
            if (etdDateTime >= curDateTime)
                return { status: "IN_PROGRESS" };
            else
                return { status: "FAILED" };
        }
        return order.orderStatus ? order.orderStatus[4] : null;
    }
    const getGap = () => {
        if (loginUser.department == 2) {
            return "";
        }
        if (order.orderStage && (order.orderStage[4].status == "IN_PROGRESS" || order.orderStage[4].status == "FAILED")) {
            var etaWH = order.orderStage[3].whStageStage[0]?.etdTime;
            var etd = order.orderStage[4].departureStage[0]?.etd;
            if (!etd)
                etd = etaWH;
            if (!etd)
                return "";
            var etdDate = new Date(etd);
            var curDate = new Date();
            var etdDateTime = etdDate.getTime();
            var curDateTime = curDate.getTime();
            if (etdDateTime >= curDateTime)
                return ""
            else {
                var diff = Number(curDateTime) - Number(etdDateTime);
                diff = diff / (3600 * 24000);
                if (diff > 99)
                    diff = 99;
                if (diff > 1)
                    return " (" + parseInt(diff) + ")";
                return "";
            }
        }
        return "";
    }

    const [openDialog, setOpenDialog] = useState(false);
    const [order1, setOrder1] = useState(false);
    const onHandleOpenDialog = () => {
        sendRequest('/api/order/' + order?.id, REQUEST_ACTIONS.GET, '', {
            successCallback: response => {
                var res = JSON.parse(JSON.stringify(response));
                setOrder1(res);
                setOpenDialog(true);
            },
            failedCallback,
        });
    }
    //const onHandleOpenDialog = () => setOpenDialog(true);

    return (
        <StyledTableCell style={{ width: "5vw", p: 0 }}>
            <StageButton stage={getStatus(order) ? getStatus(order) : null} onHandleOpenDialog={onHandleOpenDialog} stageName={'Port' + getGap()} loginUser={loginUser} />
            {openDialog && <DepartureDialog loginUser={loginUser} order={order1} openDialog={openDialog} setOpenDialog={setOpenDialog} />}
        </StyledTableCell>
    );
};

export default memo(Departure);
